import { addRegionalProjectSaga } from './addRegionalProject'
import { editRegionalProjectSaga } from './editRegionalProject'
import { deleteRegionalProjectSaga } from './deleteRegionalProject'
import { getRegionalProjectSaga } from './getRegionalProject'
import { getRegionalProjectIdSaga } from './getRegionalProjectId'

const RegionalProjectSaga = [
    addRegionalProjectSaga,
    editRegionalProjectSaga,
    deleteRegionalProjectSaga,
    getRegionalProjectSaga,
    getRegionalProjectIdSaga,
]

export default RegionalProjectSaga
